import { createStore } from "solid-js/store";

type SettingsState = {
  soundEnabled: boolean;
  notificationsEnabled: boolean;
  presentationMode: boolean;
};

const [settings, setSettings] = createStore<SettingsState>({
  soundEnabled: false,
  notificationsEnabled: false,
  presentationMode: false,
});

export { settings, setSettings };
